module.exports = __webpack_public_path__ + "static/media/7.d995546e.JPG";